import type { CSSProperties } from 'react';
import { ToastContainer } from 'react-toastify';
import { useTheme } from '@mui/material/styles';

/** Binds react-toastify's status colors to the MUI theme palette, so a toast and an
 * Alert/Chip for the same status (success/error/warning/info) always render the same
 * color instead of react-toastify's unrelated built-in defaults. */
export function AppToastContainer() {
  const theme = useTheme();

  const toastifyVars = {
    '--toastify-color-success': theme.palette.success.main,
    '--toastify-icon-color-success': theme.palette.success.main,
    '--toastify-color-progress-success': theme.palette.success.main,
    '--toastify-color-error': theme.palette.error.main,
    '--toastify-icon-color-error': theme.palette.error.main,
    '--toastify-color-progress-error': theme.palette.error.main,
    '--toastify-color-warning': theme.palette.warning.main,
    '--toastify-icon-color-warning': theme.palette.warning.main,
    '--toastify-color-progress-warning': theme.palette.warning.main,
    '--toastify-color-info': theme.palette.info.main,
    '--toastify-icon-color-info': theme.palette.info.main,
    '--toastify-color-progress-info': theme.palette.info.main,
  } as CSSProperties;

  return <ToastContainer newestOnTop style={toastifyVars} />;
}
